module.exports = {"outlet":"Station"};